import DataSource, { DataSourceService, DataSourceServiceMapDelegate, DataSourceData } from "./datasource";

export default class JsonpDataSourceService implements DataSourceService {

    private queryStringMap: DataSourceServiceMapDelegate | undefined;
    private isRunning: boolean = false
    private currentCallbackName: string | undefined;

    constructor(public readonly name: string, public readonly url: string, readonly callbackParameter: string = "callback") {
    }


    setQueryStringMap(handler: DataSourceServiceMapDelegate): JsonpDataSourceService {
        this.queryStringMap = handler;
        return this;
    }

    private buildUrl(dataSource: DataSource, argument: any): string {

        let parameters: Record<string, string> = {};

        const currentFilterText: string = dataSource?.filters[0]?.toString() || '';

        // Get Parameters
        if (this.queryStringMap) {
            parameters = this.queryStringMap({
                argument: argument,
                filterText: currentFilterText
            });
        }

        // Build QueryString
        let queryString = "";
        Object.entries(parameters).forEach(([key, value]) => {
            queryString += `${queryString !== "" ? "&" : ""}${key}=${isNullOrUndefined(value) ? "" : encodeURIComponent(value.toString())}`;
        });

        // Build Url
        const invokeUrl = this.url +
            (queryString ? (this.url.indexOf("?") === -1 ? "?" : "&") + queryString : "");

        return invokeUrl;
    }

    fetch(dataSource: DataSource, argument?: any): Promise<DataSourceData> {


        return new Promise((resolve, reject) => {

            // Build Url
            const invokeUrl = this.buildUrl(dataSource, argument);

            const callbackName = 'jsonp_callback_' + Math.round(100000 * Math.random());
            const win = window as any;
            const script: HTMLScriptElement = document.createElement('script');

            this.currentCallbackName = callbackName;

            const cleanUp = () => {
                delete win[callbackName];
                if (script) document.body.removeChild(script);
            };

            if (win[callbackName]) cleanUp()

            win[callbackName] = function(that:JsonpDataSourceService) {
                return function(data:any){
                    if (that.currentCallbackName === callbackName) {
                        cleanUp();
                        resolve(data as DataSourceData);
                    }
                }
            }(this);

            script.src = invokeUrl + (invokeUrl.indexOf('?') >= 0 ? '&' : '?') + this.callbackParameter + '=' + callbackName;
            script.async = true;
            script.onerror = _ => {
                cleanUp();
                reject(new Error(`Request to "${invokeUrl}" failed to execute.`));
            };
            document.body.appendChild(script);
        });
    }

}

function isNullOrUndefined(value: any): boolean {
    return value === undefined || value === null;
}




// export class Gbo2ItemsDataSourceService implements DataSourceService{
//     name: string;
//     fetch(dataSource: DataSource, argument?: any): Promise<DataSourceData> {

//     }

// }